import React from 'react';
import clsx from 'clsx';
import WabliAppBar from '../WabliAppbar/WabliAppBar';
import WabliBreadcrumb from '../WabliBreadcrumb';
import AboutPageMarkdown from './AboutPageMarkdown';

//  This component is responsible to render content in about_page page
const AboutPage = () => {

    const myRef= React.useRef(); // This variable is responsible to set reference of the top point of the page
    const [scrollTop, setScrollTop] = React.useState(0); // This variable stores the scroll distance from the top point of the page

    /*  This function is called when we scroll the main body of about page.
        It stores the scrolled distance, from point view to top point, to var scrollTop
    */ 
    const scrollFunction = () => {    
        setScrollTop(myRef.current.scrollTop);
    }

    return(
        <div  style={{height: '100%'}}>
            <div style={{ width: '100%', zIndex: '1000'}}> 
                <WabliAppBar />  
                <WabliBreadcrumb 
                    name= 'about' 
                />
            </div>
            {/*
                Main body of about page. When we scroll page function scrollFunction is called
            */}
            <div id='AboutPageMainBody' ref={myRef} onScroll={scrollFunction} style={{maxHeight: '82%', overflowY: 'auto',marginTop: '0.1rem'}}>
                <div   className={clsx('generalMarg','spacingTop')}  >
                    <AboutPageMarkdown scrollTop={scrollTop} /> {/* Main content of about page */}
                </div>
            </div>
                            
        </div>
    )
}

export default AboutPage;